module.exports = __webpack_public_path__ + "img/mon_24.aa94d27e.png";